import NextStepperController from './vd-next-stepper.controller'
import template from './vd-next-stepper.html'

const NextStepperComponent = {
  transclude: {
    label: '?stepLabel',
    header: '?stepHeader',
    body: 'stepBody',
  },
  bindings: {
    dott: '<?',
    reveal: '<',
  },
  controller: NextStepperController,
  template,
}

export default NextStepperComponent
